import * as React from "react";
import PropTypes from "prop-types";
import Backbone from "backbone";
import LocalSettings from "nexia_mobile/models/local_settings";
import BackboneListener from "nexia_mobile/components/BackboneListener";
import DumbNews from "./DumbNews";

export default class News extends React.Component {
  static propTypes = {
    collection: PropTypes.instanceOf(Backbone.Collection).isRequired,
  };

  state = {
    isLoading: false,
  };

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  _setStateIfMounted(...args) {
    if (this._isMounted) {
      this.setState(...args);
    }
  }

  _handleShowNewsClicked = () => {
    LocalSettings.setShowNews(!LocalSettings.getShowNews());
    this.forceUpdate();
  };

  _runPromiseWithLoadingState(promiseFn) {
    this.setState({ isLoading: true });
    const doneLoading = () => {
      this._setStateIfMounted({ isLoading: false });
    };
    promiseFn().then(doneLoading, doneLoading);
  }

  _showPreviousPage = () => {
    this._runPromiseWithLoadingState(() => {
      const { collection } = this.props;
      return collection.fetchPreviousPage();
    });
  };

  _showNextPage = () => {
    this._runPromiseWithLoadingState(() => {
      const { collection } = this.props;
      return collection.fetchNextPage();
    });
  };

  render() {
    const { collection } = this.props;

    return (
      <div data-component-name="News">
        <BackboneListener
          listenTo={collection}
          events={["add", "remove", "reset", "sort", "sync"]}
        >
          {() => {
            const { isLoading } = this.state;
            const newsItem = collection.at(0);

            return (
              <DumbNews
                hasPreviousPage={collection.hasPreviousPage()}
                showPreviousPage={this._showPreviousPage}
                hasNextPage={collection.hasNextPage()}
                showNextPage={this._showNextPage}
                isShowNewsChecked={LocalSettings.getShowNews()}
                onShowNewsClicked={this._handleShowNewsClicked}
                isLoading={isLoading}
                headline={newsItem.get("headline")}
                publishedDate={new Date(newsItem.get("published"))}
                content={newsItem.get("content")}
              />
            );
          }}
        </BackboneListener>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/News/index.jsx